import { Button } from 'primereact/button';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Pages from '../../../../config/Pages';
import { ApplicationContext } from '../../../../config/Router';
import Shareds from '../../../../config/translations/Shareds';
import { arrayToDateString } from '../../../../core/utils/DateMixins';
import { download } from '../../../../core/utils/Exporter';
import indicadorService from '../../../../service/IndicadorService';
import ModalPropostaIndicador from '../../propostaIndicador/components/modalPropostaIndicador/ModalPropostaIndicador';
import styles from './EstruturaIndicador.module.scss';

export const indicadorNavItems = {
    dadosIndicador: 'dadosIndicador',
    metasResultados: 'metasResultados',
    alterarIndicador: 'alterarIndicador',
    historico: 'historico',
};

export default function EstruturaIndicador({ children, selected, className }) {
    const {
        id: idIndicador,
        codgIndicador,
        nmIndicador,
        numrVersao,
        situacaoIndicador,
        dataProximaApuracao,
        propostaAnterior,
        proposta,
        refreshContext,
    } = useContext(ApplicationContext);
    const history = useHistory();
    const location = useLocation();
    const [isLoaded, setIsLoaded] = useState(false);
    const { id } = useParams();
    const modalRef = useRef(null);

    useEffect(() => {
        if (`${idIndicador}` !== `${id}`) {
            indicadorService.getCabecalho(id).then((response) => {
                refreshContext({
                    ...response,
                    dataProximaApuracao: arrayToDateString(response?.dataProximaApuracao),
                });
                setIsLoaded(true);
            });
        } else {
            setIsLoaded(true);
        }
    }, [idIndicador]);

    const NavButton = ({ label, icon, isActive = false, ...rest }) => (
        <div className={`${styles.navButton} ${isActive ? styles.disabledButton : ''}`}>
            <Button
                className="p-button p-component"
                icon={`pi ${icon}`}
                iconPos="top"
                disabled={isActive}
                type="button"
                {...rest}
            >
                {label}
            </Button>
        </div>
    );

    const ExternalButton = ({ label, icon, isActive = false, className = '', ...rest }) => (
        <div className={`${className} ${isActive ? styles.disabledButton : ''}`}>
            <Button
                className="p-button p-component"
                icon={`pi ${icon}`}
                iconPos="top"
                disabled={isActive}
                type="button"
                {...rest}
            >
                {label}
            </Button>
            <i className={`${styles.externalIcon} pi pi-external-link`} />
        </div>
    );

    return (
        <>
            <ModalPropostaIndicador ref={modalRef} />
            <div className={`${styles.container}`}>
                <div className={`p-col-12 p-grid ${styles.navContainer}`}>
                    <NavButton
                        label="DADOS DO INDICADOR"
                        icon="pi-info"
                        isActive={selected === indicadorNavItems.dadosIndicador}
                        onClick={() =>
                            history.push(Pages.sei.indicador.url.view.replace(':id', id))
                        }
                    />
                    <NavButton
                        label="METAS E RESULTADOS"
                        icon="pi-chart-line"
                        isActive={selected === indicadorNavItems.metasResultados}
                        onClick={() =>
                            history.push(Pages.sei.metasResultados.url.list.replace(':id', id))
                        }
                    />
                    <NavButton
                        label="ALTERAR INDICADOR"
                        icon="pi-pencil"
                        isActive={
                            selected === indicadorNavItems.alterarIndicador ||
                            situacaoIndicador?.codgSituacaoIndicador !== 'EM_ALTERACAO'
                        }
                        onClick={() =>
                            history.push(Pages.sei.indicador.url.edit.replace(':id', id))
                        }
                    />
                    <NavButton
                        label="HISTÓRICO"
                        icon="pi-history"
                        isActive={selected === indicadorNavItems.historico}
                        onClick={() =>
                            history.replace({
                                ...location,
                                pathname: Pages.sei.historicoIndicador.url.list.replace(':id', id),
                                state: { from: location.pathname },
                            })
                        }
                    />
                    <ExternalButton
                        className={styles.externalButton}
                        label="PROPOSTA"
                        icon="pi-file"
                        onClick={() =>
                            modalRef.current?.show(
                                propostaAnterior?.id ? propostaAnterior : proposta
                            )
                        }
                    />
                    <ExternalButton
                        className={styles.externalButton}
                        label="STATUS"
                        icon="pi-arrow-right-arrow-left"
                        onClick={() =>
                            history.replace({
                                ...location,
                                pathname: Pages.sei.statusProposta.url.list.replace(
                                    ':id',
                                    propostaAnterior?.id ?? proposta?.id
                                ),
                                state: { from: location.pathname },
                            })
                        }
                    />
                    <NavButton
                        className={styles.externalButton}
                        label="RELATÓRIO DADOS DO INDICADOR"
                        icon="pi-print"
                        onClick={async () => {
                            const arquivo = await indicadorService.getRelatorioIndicador(id);
                            download(arquivo, 'Dados Indicador', 'pdf');
                        }}
                    />
                </div>
                <div className={`${styles.stateBar}`}>
                    <div>
                        <span>Cód. Indicador:</span>
                        <div>{codgIndicador ?? Shareds.naoDefinido}</div>
                    </div>
                    <div>
                        <span>Nome:</span>
                        <div>{nmIndicador ?? Shareds.naoDefinido}</div>
                    </div>
                    <div>
                        <span>Versão:</span>
                        <div>{numrVersao ?? Shareds.naoDefinido}</div>
                    </div>
                    <div>
                        <span>Situação:</span>
                        <div>{situacaoIndicador?.descSituacaoIndicador ?? Shareds.naoDefinido}</div>
                    </div>
                    <div>
                        <span>Cód. Proposta:</span>
                        <div>{propostaAnterior?.id ?? proposta?.id ?? Shareds.naoDefinido}</div>
                    </div>
                    <div>
                        <span>Próxima Apuração:</span>
                        <div>{dataProximaApuracao ?? Shareds.naoDefinido}</div>
                    </div>
                </div>
                <div className={`${styles.childrenContainer} ${className ?? ''}`}>
                    {isLoaded && children}
                </div>
            </div>
        </>
    );
}
